import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { isUserBusiness } from 'libs/shared/data/stores/auth/auth.reducer';
import { selectUserBusinessEntity } from 'libs/shared/data/stores/auth/auth.selectors';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserEntityGuard implements CanActivate {
  private store$ = inject(Store);
  private router = inject(Router);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store$.select(selectUserBusinessEntity).subscribe({
        next: (res) => {
          if (isUserBusiness(res)) {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('Forbidden access'),
              detail: this.translateService.instant(
                'You cannot access this module with a business profile!',
              ),
            });
            observer.next(false);
            this.router.navigate(['/business-access-denied']);
          }
          observer.next(true);
        },
        error: () => {
          observer.next(false);
        },
      });
    });
  }
}
